import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ExternalLink } from "lucide-react";
import { IconBrandInstagram } from "@tabler/icons-react";
import { Skeleton } from "@/components/ui/skeleton";

const InstagramSection = () => {
  const { data: posts = [], isLoading } = useQuery({
    queryKey: ["instagram-posts"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("instagram_posts")
        .select("*")
        .eq("is_active", true)
        .order("created_at", { ascending: false })
        .limit(5);
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 60_000,
  });

  if (!isLoading && posts.length === 0) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <IconBrandInstagram size={24} stroke={1.5} className="text-primary" />
          <h2 className="font-display text-2xl md:text-3xl font-bold">@padelcorner.lv</h2>
        </div>
        <a
          href="https://instagram.com/padelcorner.lv"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden sm:inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
        >
          Skatīt vairāk <ExternalLink size={14} />
        </a>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
        {isLoading
          ? Array.from({ length: 5 }).map((_, i) => (
              <Skeleton key={i} className="aspect-square rounded-lg" />
            ))
          : posts.map((post) => (
              <a
                key={post.id}
                href={post.post_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative aspect-square rounded-lg overflow-hidden bg-muted border border-border shadow-sm hover:shadow-md transition-all"
              >
                <img
                  src={post.image_url}
                  alt={post.caption || "Instagram post"}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-foreground/0 group-hover:bg-foreground/20 transition-colors flex items-center justify-center">
                  <IconBrandInstagram
                    size={28}
                    className="text-background opacity-0 group-hover:opacity-100 transition-opacity drop-shadow-lg"
                  />
                </div>
              </a>
            ))}
      </div>

      <div className="mt-4 text-center sm:hidden">
        <a
          href="https://instagram.com/padelcorner.lv"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:underline"
        >
          Skatīt vairāk Instagram <ExternalLink size={14} />
        </a>
      </div>
    </div>
  );
};

export default InstagramSection;
